module.exports = __webpack_public_path__ + "static/media/boy-14.63d9b009.svg";